/**
 * @generated SignedSource<<7f378cfbe0718900ef5ae5d88b796a17>>
 * @relayHash 86c02a3f9408f99ecddfb0097e0b38b5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9fc808f5f11710e3379f1b5c18c87f236c94f04d073d912624035cb56b44be39

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type proposalDiffPageQuery$variables = {
  proposalId: string;
};
export type proposalDiffPageQuery$data = {
  readonly schemaProposal: {
    readonly author: {
      readonly id: string;
    } | null | undefined;
    readonly id: string;
    readonly revision: number;
    readonly subgraphs: ReadonlyArray<{
      readonly diffSnippets: ReadonlyArray<{
        readonly addedLines: ReadonlyArray<number>;
        readonly originalSchemaSnippet: string;
        readonly originalSchemaSnippetFirstLine: number;
        readonly proposedSchemaSnippet: string;
        readonly proposedSchemaSnippetFirstLine: number;
        readonly removedLines: ReadonlyArray<number>;
      }>;
      readonly name: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"eventsTimelineContextProviderFragment" | "useGetCommentsOnLinesProposalFragment">;
  };
  readonly viewer: {
    readonly avatarUrl: string | null | undefined;
    readonly id: string;
    readonly name: string;
  };
};
export type proposalDiffPageQuery = {
  response: proposalDiffPageQuery$data;
  variables: proposalDiffPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "proposalId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "avatarUrl",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "proposalId"
  }
],
v6 = [
  (v1/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revision",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "SchemaProposalSubgraph",
  "kind": "LinkedField",
  "name": "subgraphs",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "DiffSnippet",
      "kind": "LinkedField",
      "name": "diffSnippets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalSchemaSnippet",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalSchemaSnippetFirstLine",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "proposedSchemaSnippet",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "proposedSchemaSnippetFirstLine",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "addedLines",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "removedLines",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v14 = [
  (v2/*: any*/),
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "proposalDiffPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v4/*: any*/),
        "action": "THROW"
      },
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "SchemaProposal",
          "kind": "LinkedField",
          "name": "schemaProposal",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useGetCommentsOnLinesProposalFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "eventsTimelineContextProviderFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "proposalDiffPageQuery",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "SchemaProposal",
        "kind": "LinkedField",
        "name": "schemaProposal",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "activityFeed",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "line",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subgraphName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "diffSide",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "contextLines",
                        "value": 5
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "context",
                    "storageKey": "context(contextLines:5)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resolved",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "resolvedBy",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SchemaProposalReply",
                    "kind": "LinkedField",
                    "name": "replies",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "SchemaProposalCommentOnLine",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "SchemaProposalApproval",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "SchemaProposalCommentOnProposal",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "SchemaProposalCommentOnSdl",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "SchemaProposalRejection",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "SchemaProposalReviewRequest",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "reviewers",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "onBehalfOf",
                    "plural": true,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "SchemaProposalReviewerUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86c02a3f9408f99ecddfb0097e0b38b5",
    "id": "9fc808f5f11710e3379f1b5c18c87f236c94f04d073d912624035cb56b44be39",
    "metadata": {},
    "name": "proposalDiffPageQuery",
    "operationKind": "query",
    "text": "query proposalDiffPageQuery(\n  $proposalId: ID!\n) {\n  viewer {\n    id\n    name\n    avatarUrl\n  }\n  schemaProposal(id: $proposalId) {\n    id\n    author {\n      id\n    }\n    revision\n    subgraphs {\n      name\n      diffSnippets {\n        originalSchemaSnippet\n        originalSchemaSnippetFirstLine\n        proposedSchemaSnippet\n        proposedSchemaSnippetFirstLine\n        addedLines\n        removedLines\n      }\n    }\n    ...useGetCommentsOnLinesProposalFragment\n    ...eventsTimelineContextProviderFragment\n  }\n}\n\nfragment eventsTimelineContextProviderFragment on SchemaProposal {\n  id\n  reviewers {\n    __typename\n    ... on SchemaProposalReviewerUser {\n      __typename\n      user {\n        id\n      }\n      onBehalfOf {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment eventsTimelineProposalCommentOnLineFragment on SchemaProposalCommentOnLine {\n  id\n  text\n  createdAt\n  author {\n    id\n    name\n    avatarUrl\n  }\n  __typename\n  line\n  subgraphName\n  diffSide\n  context(contextLines: 5)\n  resolved\n  resolvedBy {\n    name\n    id\n  }\n  replies {\n    id\n    text\n    createdAt\n    author {\n      id\n      name\n      avatarUrl\n    }\n  }\n}\n\nfragment useGetCommentsOnLinesProposalFragment on SchemaProposal {\n  activityFeed {\n    __typename\n    ... on SchemaProposalCommentOnLine {\n      __typename\n      id\n      line\n      subgraphName\n      diffSide\n      ...eventsTimelineProposalCommentOnLineFragment\n    }\n    ... on SchemaProposalApproval {\n      id\n    }\n    ... on SchemaProposalCommentOnProposal {\n      id\n    }\n    ... on SchemaProposalCommentOnSdl {\n      id\n    }\n    ... on SchemaProposalRejection {\n      id\n    }\n    ... on SchemaProposalReviewRequest {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8f74f1bef5f34ed3552be6607111d58";

export default node;
